import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ToursPage from "@/pages/ToursPage";
import TourDetailsPage from "@/pages/TourDetailsPage";
import FlightsPage from "@/pages/FlightsPage";
import CruisesPage from "@/pages/CruisesPage";
import AntarcticaPage from "@/pages/AntarcticaPage";
import ContactPage from "@/pages/ContactPage";
// Service Pages
import GuidedToursPage from "@/pages/GuidedToursPage";
import FlightBookingsPage from "@/pages/FlightBookingsPage";
import CruisePackagesPage from "@/pages/CruisePackagesPage";
import CustomItinerariesPage from "@/pages/CustomItinerariesPage";
import GroupTravelPage from "@/pages/GroupTravelPage";
import HoneymoonPackagesPage from "@/pages/HoneymoonPackagesPage";
// New SEO Pages
import AboutPage from "@/pages/AboutPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import ReviewsPage from "@/pages/ReviewsPage";
import InternationalFlightBookingPage from "@/pages/InternationalFlightBookingPage";
import FlightsToIndiaPage from "@/pages/FlightsToIndiaPage";
import FlightsToAfricaPage from "@/pages/FlightsToAfricaPage";
import CustomTourPackagesPage from "@/pages/CustomTourPackagesPage";
import GroupTravelPlanningPage from "@/pages/GroupTravelPlanningPage";
import CruiseBookingAssistancePage from "@/pages/CruiseBookingAssistancePage";
// Blog
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
// Legal Pages
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";

function RouteChangeHandler() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const main = document.getElementById("main-content");
    if (main) {
      main.setAttribute("tabindex", "-1");
      main.focus({ preventScroll: true });
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <RouteChangeHandler />
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tours" element={<ToursPage />} />
        <Route path="/tours/:id" element={<TourDetailsPage />} />
        <Route path="/flights" element={<FlightsPage />} />
        <Route path="/cruises" element={<CruisesPage />} />
        <Route path="/expeditions/antarctica" element={<AntarcticaPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Service Pages */}
        <Route path="/services/guided-tours" element={<GuidedToursPage />} />
        <Route path="/services/flight-bookings" element={<FlightBookingsPage />} />
        <Route path="/services/cruise-packages" element={<CruisePackagesPage />} />
        <Route path="/services/custom-itineraries" element={<CustomItinerariesPage />} />
        <Route path="/services/group-travel" element={<GroupTravelPage />} />
        <Route path="/services/honeymoon-packages" element={<HoneymoonPackagesPage />} />
        {/* New SEO Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/international-flight-booking" element={<InternationalFlightBookingPage />} />
        <Route path="/flights-to-india-from-usa" element={<FlightsToIndiaPage />} />
        <Route path="/flights-to-africa-from-usa" element={<FlightsToAfricaPage />} />
        <Route path="/custom-tour-packages" element={<CustomTourPackagesPage />} />
        <Route path="/group-travel-planning" element={<GroupTravelPlanningPage />} />
        <Route path="/cruise-booking-assistance" element={<CruiseBookingAssistancePage />} />
        {/* Blog */}
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
